import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../navigation/header";
import Footer from "../navigation/footer";
import SideNav from "../navigation/sideNav";
import { useAuth } from "../auth/authContext";
import { flattenNavItems } from "../navigation/navDataUtils";

const ProtectedRoute = ({ navData }) => {
  const { isAuthenticated, openSideNav, authReady } = useAuth();
  const location = useLocation();

  // Check if the current route is allowed. Sub-paths (e.g. "/x/add", "/x/edit/:id")
  // are write actions, so they require write permission on the matching nav item -
  // otherwise a read-only role could reach create/edit forms by typing the URL.
  const matchingNavItem = flattenNavItems(navData).find(
    (navItem) =>
      navItem.link === location.pathname ||
      location.pathname.startsWith(`${navItem.link}/`)
  );
  const isAllowedPath = Boolean(
    matchingNavItem &&
      (matchingNavItem.link === location.pathname || matchingNavItem.write)
  );

  useEffect(() => { }, [openSideNav]);

  if (!authReady) {
    return null;
  }

  if (isAuthenticated && navData.length === 0) {
    return null;
  }

  return isAuthenticated && isAllowedPath ? (
    <>
      <Header />
      <div className="d-flex" style={{ minHeight: "95vh" }}>
        <SideNav />
        <div
          style={{ padding: "2rem" }}
          className={
            openSideNav === true
              ? " bg_color mainCont"
              : " bg_color mainContClosed"
          }
        >
          <Outlet />
          <Footer />
        </div>
      </div>
    </>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
